<template>
    <carousel :perPage="1">
        <slide class="p-2">
            <b-card>
                <div class="row">
                    <div class="col-md-2 col-sm-12">
                        <div class="callout callout-success">
                            <small class="text-muted">Saldo disponível</small>
                            <h4 class="h4">{{ available }}</h4>
                        </div>
                    </div>
                </div>
            </b-card>
        </slide>
        <slide class="p-2">
            <b-card>
                <div class="row">
                    <div class="col-md-2 col-sm-12">
                        <div class="callout callout-warning">
                            <small class="text-muted">A Receber</small>
                            <h4 class="h4">{{ inProcess }}</h4>
                        </div>
                    </div>
                </div>
            </b-card>
        </slide>
        <slide class="p-2">
            <b-card>
                <div class="row">
                    <div class="col-md-2 col-sm-12">
                        <div class="callout">
                            <small class="text-muted">Total</small>
                            <h4 class="h4">{{ total }}</h4>
                        </div>
                    </div>
                </div>
            </b-card>
        </slide>
        <slide class="p-2">
            <b-card>
                <div class="row">
                    <div class="col-md-2 col-sm-12">
                        <div class="callout callout-danger">
                        <small class="text-muted">Valor bloqueado</small>
                        <h4 class="h4">{{blocked}}</h4>
                        </div>
                    </div>
                </div>
            </b-card>
        </slide>
        <slide class="p-2">
            <b-card>
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <div class="callout callout-danger">
                        <small class="text-muted">Debitos em aberto</small>
                        <h4 class="h4">{{openDebits}}</h4>
                        </div>
                    </div>
                </div>
            </b-card>
        </slide>
    </carousel>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name:'balance-summary',
    components: {
        Carousel,
        Slide
    },
    props: {
        customerId: {
            type: String,
            default: ''
        },
        customerType: {
            type: String,
            default: ''
        },
        value: {
            type: Object,
            default: { available: 0, inProcess: 0, blocked: 0, total: 0, openDebits: 0 }
        }
    },
    watch: {
        value() {
            this.$emit('input', this.value);            
        }   
    },
    computed: {
        available() {
            return this.value.available.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        inProcess() {
            return this.value.inProcess.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        blocked() {
            return this.value.blocked.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        openDebits() {
            return this.value.openDebits.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        total() {
            return this.value.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
    }    
}
</script>